import React, { useEffect, useState } from 'react'
import { getSingleFgItem, keyValueItems, submitFgItems } from '../../../services/Inventory/ItemService'
import Select from "react-select";
import toast, { Toaster } from 'react-hot-toast';
import Button from "@mui/material/Button";
import { PlusOneOutlined } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';

export const AddEditFGitemsales = () => {
  const navigate = useNavigate()
  const [itemsOption, setItemsOption] = useState([])
  const [formData, setFormData] = useState({
    title: "",
    selectedDate: "",
    endDate: ""
  })
  const [rows, setRows] = useState([{
    itemTitle: "",
    unitTitle: "",
    quantity: 0,
    unitId: "",
    itemId: ""
  }])

  let { id } = useParams()


  useEffect(() => {
    if (id) {
      getSingleFgItem(id).then((res) => ({})).catch((err) => ({}))
    }
  }, [id])

  useEffect(() => {
    keyValueItems().then((e) => {
      setItemsOption(e.responsePacket.map((e) => {
        return {
          label: e.value1,
          value: e.key1,
          ...e
        }
      }))
    })
  }, [])


  const handleAddRow = () => {
    setRows((prev) => [...prev, {
      itemTitle: "",
      unitTitle: "",
      quantity: 0,
      unitId: "",
      itemId: ""
    }])

  }
  const handleSave = () => {
    let ValidationData = rows.find((e) => !e.itemId || !e.quantity || !e.unitTitle)
    if (ValidationData) {
      toast.error("Can not submit with empty values");
      return;

    }
    let payload = {
      selectedDate: formData.selectedDate,
      fromDate: formData.fromDate,
      title: formData.title,
      items: rows
    }
    submitFgItems(payload).then(e => {
      toast(e.message);
      setRows([{
        itemTitle: "",
        unitTitle: "",
        quantity: 0,
        unitId: "",
        itemId: ""
      }])
      navigate("/salestarget")
    }
    )
      .catch((err) =>
        console.error("err", err)
      )
  }


  const handleItemSelect = (item, i) => {
    let data = [...rows]
    data[i] = { ...data[i], itemId: item.value, unitTitle: item.value2, itemTitle: item.label, unitId: item.key2 }
    setRows(data)
  }
  const handleStock = (e, i) => {
    let data = [...rows]
    data[i] = { ...data[i], quantity: e.target.value }
    setRows(data)

  }
  const removeSubRows = (indexToRemove) => {
    setRows((prevRows) => prevRows.filter((_, idx) => idx !== indexToRemove));
  };


  return (
    <div className="p-4">
      {/* <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-0 font-size-18 font-weight-bolder text-uppercase w-100">
          FG Items
        </h3>
      </div> */}
      <div className="fill list-header  bg-white p-3 border-bottom">
        <h1><b>FG Sales</b></h1>
      </div>

      <table style={{ width: "500px" }} className="customTable">
        <tbody>
          <tr>
            <td >Title:</td>
            <td>
              <input
                autoComplete="off"
                placeholder="Enter Target Title "
                className="form-control"
                value={formData.title}
                onChange={(e) =>
                  setFormData((prev) => {
                    return { ...prev, title: e.target.value }
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td >Select Date:</td>
            <td>
              <input
                autoComplete="off"
                type="date"
                className="form-control"
                value={formData.selectedDate}
                onChange={(e) => {
                  const selectedDate = new Date(e.target.value);
                  const prevMonthDate = new Date(selectedDate);
                  prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);

                  const formatDate = (date) => {
                    const yyyy = date.getFullYear();
                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                    const dd = String(date.getDate()).padStart(2, '0');
                    return `${yyyy}-${mm}-${dd}`;
                  };

                  setFormData((prev) => ({
                    ...prev,
                    selectedDate: e.target.value,
                    fromDate: formatDate(prevMonthDate)
                  }));
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div className='mt-4'>
        <table className="customTable">
          <tr>
            <td style={{ width: "200px" }}>Items</td>
            <td>Qty</td>
            <td>UOM</td>
            <td></td>
          </tr>
          {rows &&
            rows.map((item, i) => {
              return (
                <>
                  <tr key={i}>
                    <td style={{ width: "200px" }}>
                      <Select options={itemsOption.filter((e) => !rows.find((f) => f.itemId == e.key1))} value={{
                        label: item.itemTitle,
                        value: item.itemId
                      }} onChange={(e) => handleItemSelect(e, i)} />
                    </td>
                    <td>
                      <input autoComplete="off" className="form-control" type="number" min={0} value={item.quantity} onChange={(e) => handleStock(e, i)} />
                    </td>
                    <td>
                      <input className="form-control" disabled={true} min={0} value={item?.unitTitle} />
                    </td>
                    <td> <button
                      className="btn btn-default addbtn"
                      onClick={() => removeSubRows(i)}
                      disabled={rows.length < 2}
                    >
                      X
                    </button></td>
                  </tr>
                </>
              );
            })}
        </table>
      </div>
      <div>
        <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handleAddRow}>
          <PlusOneOutlined style={{ color: "blue" }} /> New Row
        </button>
      </div>

      <br />
      <div>
        {/* {loading ? (
          <Button variant="contained">
            <Spinner />
          </Button>
        ) : ( */}
        <Button variant="contained" onClick={() => handleSave()}>
          Submit
        </Button>
        {/* )} */}
      </div>
      <Toaster />
    </div>
  )
}
